export default __webpack_public_path__ + "static/media/blue-light.94b2cc05.svg";